module.exports = __webpack_public_path__ + "img/selbsterfahrung_3000.57326f4a.webp";